import EthnicAPI from '@/apis/business/ethnicAPI'
import CrudBase from '@/stores/crudBase.js'

const crudBase = new CrudBase('Ethnic', EthnicAPI)
export default {
  namespaced: true,
  state: {
    ...crudBase.state,
  },
  mutations: {
    ...crudBase.mutations,
  },
  getters: {
    ...crudBase.getters,
  },
  actions: {
    ...crudBase.actions,
  },
}
